export const postsPath = {
  /* inject path */
  YOUTUBE_SENTIMENT_ANALYSIS:
    '/posts/youtube-sentiment-analysis/:id/:remote_id',
  YOUTUBE_SENTIMENT_ANALYSIS_URI: '/posts/youtube-sentiment-analysis',
  ADD_YOUTUBE_POST: '/posts/add-youtube-post',
  YOUTUBE_POST_DETAILS: '/posts/youtube-post-details/:id',
  YOUTUBE_POST_DETAILS_URI: '/posts/youtube-post-details',
  ADD_LINKEDIN_POST: '/posts/add-linkedin-post',
  ADD_TWITTER_POST: '/posts/add-twitter-post',
  LINKEDIN_SENTIMENT_ANALYSIS:
    '/posts/linkedin-sentiment-analysis/:id/:remote_id',
  LINKEDIN_SENTIMENT_ANALYSIS_URI: '/posts/linkedin-sentiment-analysis',
  TWITTER_SENTIMENT_ANALYSIS:
    '/posts/twitter-sentiment-analysis/:id/:remote_id',
  TWITTER_SENTIMENT_ANALYSIS_URI: '/posts/twitter-sentiment-analysis',
  LINKEDIN_POST_DETAILS: '/posts/linkedin-post-details/:id',
  LINKEDIN_POST_DETAILS_URI: '/posts/linkedin-post-details',
  TWITTER_POST_DETAILS: '/posts/twitter-post-details/:id',
  TWITTER_POST_DETAILS_URI: '/posts/twitter-post-details',
  YOUTUBE_POSTS_TABLE: '/posts/youtube-posts-table',
  TWITTER_POSTS_TABLE: '/posts/twitter-posts-table',
  TIKTOK_SENTIMENT_ANALYSIS: '/posts/tiktok-sentiment-analysis/:id/:remote_id',
  TIKTOK_SENTIMENT_ANALYSIS_URI: '/posts/tiktok-sentiment-analysis',
  ADD_NEW_TIKTOK_POST: '/posts/add-new-tiktok-post',
  TIKTOK_POST_DETAILS: '/posts/tiktok-post-details/:id',
  TIKTOK_POST_DETAILS_URI: '/posts/tiktok-post-details',
  TIKTOK_POSTS_TABLE: '/posts/tiktok-posts-table',
  INSTAGRAM_SENTIMENT_ANALYSIS:
    '/posts/instagram-sentiment-analysis/:id/:postCode',
  INSTAGRAM_SENTIMENT_ANALYSIS_URI: '/posts/instagram-sentiment-analysis',
  ADD_INSTAGRAM_POST: '/posts/add-instagram-post',
  INSTAGRAM_POSTS_DETAILS: '/posts/instagram-posts-details/:id',
  INSTAGRAM_POSTS_DETAILS_URI: '/posts/instagram-posts-details',
  DASHBOARD: '/posts/dashboard',
  LINKEDIN_POSTS_TABLE: '/posts/linkedin-posts-table',
  INSTAGRAM_TABLE: '/posts/instagram-posts-table',
};
